import { render } from "./atcs-main.html?vue&type=template&id=495174fc&scoped=true&ts=true&external"
import script from "./atcs-main.ts?vue&type=script&lang=ts&external"
export * from "./atcs-main.ts?vue&type=script&lang=ts&external"

import "./atcs-main.scss?vue&type=style&index=0&id=495174fc&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495174fc"]])

export default __exports__